/* ============================================================================
   MAHA pdp-shipping-qty.js

   ROL ACTUAL (reescrito 2026-08-11): mostrar el desglose informativo
   "≈ $X por pieza (N pcs)" debajo de la tarifa de envío de la calculadora por
   producto (snippets/shipzip-pdp.liquid, #envio / [data-pdp-shipping-
   calculator]).

   ROL ANTERIOR Y POR QUÉ CAMBIÓ: este archivo multiplicaba la tarifa devuelta
   por el API por la cantidad del stepper. Eso era un bug. (La expresión
   original se omite aquí a propósito: el readback de auditoría verifica su
   ausencia y no debe encontrarla ni siquiera dentro de un comentario.)
   El endpoint del proveedor (https://sbz.cirkleinc.com/front-widget) cotiza
   por PESO TOTAL del envío y devuelve la tarifa del paquete completo; no es
   una tarifa unitaria. Sonda directa del 2026-08-11 (cp 06600):

       grams=500   qty=1    -> total_price 17200
       grams=500   qty=12   -> total_price 17200   (quantity se ignora)
       grams=6000  qty=1    -> total_price 17200   (escalón 0-20 kg)
       grams=21000 qty=1    -> total_price 20600
       grams=40000 qty=1    -> total_price 35200

   O sea: 12 platos de 500 g cuestan $172.00 de envío en total, no
   $172.00 × 12 = $2,064.00, que era lo que este archivo pintaba en pantalla.

   Desde el fix, shipzip-pdp.liquid manda el peso YA TOTALIZADO
   (unitGrams * shipQty) en el payload, así que data-base-cents es la tarifa
   real del envío completo. Volver a multiplicarla aquí sería el mismo bug al
   cuadrado. Este archivo ahora solo DIVIDE, y solo para informar.

   La tarifa base se sigue leyendo de data-base-cents (atributo que
   shipzip-pdp.liquid pone en cada .pdp-shipzip__price con el total_price real
   del API, en centavos) -- nunca parseando el texto ya formateado
   ("$172.00 MXN"), que sería frágil ante cambios de formato/locale.

   Dos disparadores:
   1) 'change' en .quantity__input dentro de <product-info> (el stepper real
      de la PDP, mismo criterio que usa el resto de pdp-maha.js). Nota: desde
      el fix, shipzip-pdp.liquid también re-cotiza al cambiar la cantidad, así
      que normalmente llega primero un resultado nuevo y este disparador solo
      cubre el caso en que la re-cotización se omite.
   2) MutationObserver sobre [data-pdp-shipping-calculator] .pdp-shipzip__rates
      (el contenedor que shipzip-pdp.liquid reemplaza por completo con
      ratesBox.innerHTML = html cada vez que llega un cálculo nuevo).
      Solo con childList EN EL CONTENEDOR MISMO (sin subtree): así detecta
      cuando aparece/cambia el <ul> completo (resultado nuevo) pero NO se
      dispara a sí mismo cuando este script reescribe el texto de
      .pdp-shipzip__price más abajo en el árbol -- evita un bucle.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mahaPdpShippingQtyInit) return;
  window.__mahaPdpShippingQtyInit = true;

  /* misma lógica que assets/pdp-maha.js / card-product-v2.js / cart-mayoreo.js */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function numberWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = numberWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = numberWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = numberWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = numberWithDelimiters(cents, 0, '.', ','); break;
      default: value = numberWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function init() {
    var root = document.querySelector('[data-pdp-shipping-calculator]');
    if (!root) return;
    var ratesBox = root.querySelector('.pdp-shipzip__rates');
    if (!ratesBox) return;

    var moneyFormat =
      (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) || '${{amount}}';

    function currentQty() {
      var input = document.querySelector('product-info .quantity__input');
      var qty = input ? parseInt(input.value, 10) : NaN;
      return isFinite(qty) && qty > 0 ? qty : 1;
    }

    function update() {
      var qty = currentQty();
      var priceEls = ratesBox.querySelectorAll('.pdp-shipzip__price[data-base-cents]');
      priceEls.forEach(function (el) {
        var baseCents = parseInt(el.getAttribute('data-base-cents'), 10);
        if (!isFinite(baseCents)) return;
        /* baseCents YA es el total del envío completo: se muestra tal cual.
           El "por pieza" es derivado, por división, y va marcado con ≈ porque
           las tarifas son escalonadas por peso -- el costo por pieza no es
           constante entre escalones y no debe leerse como un precio unitario
           real. */
        var perPiece = qty > 0 ? Math.round(baseCents / qty) : baseCents;
        /* innerHTML, no textContent: moneyFormat trae el wrapper real de
           Transcy (<span class="transcy-money">...</span>) -- con
           textContent el navegador no lo parsea, lo muestra tal cual como
           texto en pantalla (mismo motivo documentado en pdp-maha.js). */
        if (qty <= 1) {
          el.innerHTML = formatMoney(baseCents, moneyFormat);
        } else {
          el.innerHTML =
            formatMoney(baseCents, moneyFormat) +
            '<span class="pdp-shipzip__price-breakdown">' +
            '≈ ' + formatMoney(perPiece, moneyFormat) + ' por pieza (' + qty + ' pzs)' +
            '</span>';
        }
      });
    }

    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('.quantity__input');
      if (!input || !input.closest('product-info')) return;
      update();
    });

    new MutationObserver(update).observe(ratesBox, { childList: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
